/* Aurora: sticky cart bar opens mini-cart popup; header cart icon opens the cart page. */
(function(){
'use strict';
var ALX_FREE_DC=4000;
/* dark patch: component-cart-drawer.css paints header/thead with the (white) scheme background */
var css='cart-drawer .drawer__header{background:transparent!important}'
+'cart-drawer .drawer__heading{color:#fff!important}'
+'cart-drawer .cart-items thead,cart-drawer .cart-items th{background:transparent!important;color:rgba(244,241,250,.6)!important}'
+'cart-drawer .cart-items thead tr{background:rgba(19,16,34,.96)!important}'
+'cart-drawer .drawer__close{color:#fff!important}cart-drawer .drawer__close svg{color:#fff}'
+'body.alx-cbar-live .alx-sticky{display:none!important}';
var tag=document.createElement('style');tag.textContent=css;
(document.head||document.documentElement).appendChild(tag);

function isMobile(){
  return window.matchMedia('(max-width: 989px)').matches || window.matchMedia('(hover: none) and (pointer: coarse)').matches;
}

/* ===== drawer refresh (fresh cart contents before opening) ===== */
function refreshDrawer(done){
  fetch('/?sections=cart-drawer').then(function(r){return r.json();}).then(function(d){
    var html=d&&d['cart-drawer'];
    if(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var fresh=doc.querySelector('cart-drawer');
      var cur=document.querySelector('cart-drawer');
      if(fresh&&cur){
        var fi=fresh.querySelector('.drawer__inner'),ci=cur.querySelector('.drawer__inner');
        if(fi&&ci)ci.innerHTML=fi.innerHTML;
        cur.classList.toggle('is-empty',fresh.classList.contains('is-empty'));
      }
    }
    done();
  }).catch(function(){done();});
}

/* header cart icon → always the full cart page (block Dawn's drawer binding, let the link navigate) */
document.addEventListener('click',function(e){
  var link=e.target.closest('#cart-icon-bubble');
  if(!link)return;
  e.stopPropagation();
},true);

/* ===== mobile sticky cart bar: items + total + free-DC nudge ===== */
var cartBar=null,lastCount=0;
function fmtRs(n){return 'Rs.'+Math.round(n).toLocaleString();}
function ensureCartBar(){
  if(cartBar)return cartBar;
  cartBar=document.createElement('div');cartBar.className='alx-cartbar';
  cartBar.innerHTML='<div class="alx-cb-dc"><span class="alx-cb-dc-txt"></span><i><b></b></i></div>'
    +'<div class="alx-cb-row"><div class="alx-cb-info"><b class="alx-cb-count"></b><span class="alx-cb-total"></span></div><span class="alx-cb-btn">VIEW CART →</span></div>';
  document.body.appendChild(cartBar);
  cartBar.addEventListener('click',function(){
    var drawer=document.querySelector('cart-drawer');
    if(drawer&&typeof drawer.open==='function'){
      refreshDrawer(function(){drawer.open(cartBar);});
    }else{window.location.href='/cart';}
  });
  return cartBar;
}
function barAllowed(){
  if(!(isMobile()||window.__alxCartBarForce))return false;
  if(location.pathname.indexOf('/cart')===0)return false;
  var drawer=document.querySelector('cart-drawer');
  if(drawer&&drawer.classList.contains('active'))return false;
  var pop=document.querySelector('.alx-pop-wrap.alx-on');
  if(pop)return false;
  return true;
}
function paintCartBar(){
  /* cart has items → cart bar wins over the product ATC sticky bar */
  document.body.classList.toggle('alx-cbar-live',lastCount>0&&(isMobile()||window.__alxCartBarForce));
  if(!cartBar)return;
  if(lastCount>0&&barAllowed())cartBar.classList.add('alx-on');
  else cartBar.classList.remove('alx-on');
}
function updateCartBar(){
  if(!(isMobile()||window.__alxCartBarForce))return;
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
    lastCount=c.item_count||0;
    if(!lastCount){paintCartBar();return;}
    var bar=ensureCartBar();
    bar.querySelector('.alx-cb-count').textContent=lastCount+(lastCount>1?' items':' item')+' in cart';
    var total=(c.total_price||0)/100;
    bar.querySelector('.alx-cb-total').textContent=fmtRs(total);
    var txt=bar.querySelector('.alx-cb-dc-txt'),fill=bar.querySelector('.alx-cb-dc i b'),dc=bar.querySelector('.alx-cb-dc');
    if(total>=ALX_FREE_DC){
      dc.classList.add('alx-cb-dc-ok');
      txt.innerHTML='🎉 <b>FREE Delivery unlocked!</b>';
      fill.style.width='100%';
    }else{
      dc.classList.remove('alx-cb-dc-ok');
      txt.innerHTML='🚚 Add <b>'+fmtRs(ALX_FREE_DC-total)+'</b> more for <b>FREE Delivery</b>';
      fill.style.width=Math.max(6,Math.min(100,total/ALX_FREE_DC*100))+'%';
    }
    paintCartBar();
  }).catch(function(){});
}
/* refresh after any cart change */
try{
  var _f=window.fetch;
  window.fetch=function(){
    var p=_f.apply(this,arguments);
    try{
      var a=arguments[0];
      var u=String((a&&a.url)||a||'');
      if(/\/cart\/(add|change|update|clear)/.test(u)){p.then(function(){setTimeout(updateCartBar,400);},function(){});}
    }catch(e){}
    return p;
  };
}catch(e){}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',updateCartBar);}else{updateCartBar();}
setInterval(updateCartBar,8000);
window.addEventListener('scroll',function(){paintCartBar();},{passive:true});
document.addEventListener('DOMContentLoaded',function(){
  var cd=document.querySelector('cart-drawer');
  if(cd){try{new MutationObserver(function(){paintCartBar();}).observe(cd,{attributes:true,attributeFilter:['class']});}catch(e){}}
});
window.__alxUpdateCartBar=updateCartBar;
})();
